import { faCalendarLines } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import CtaSection, { CtaSectionProps } from './cta/cta-section.component';

import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { SearchType } from '@/types/most-search-type';

interface CtaIndexCardProps extends CtaSectionProps {
  specialtyName?: string;
  title: string;
  searchType: SearchType;
  originCta: string;
}

export function CtaIndexCard({ rules, procedure, place, title, branches, searchType, originCta }: CtaIndexCardProps) {
  return (
    <div className="mb-5">
      <Card className="flex flex-col items-start p-6 bg-white rounded-lg shadow-md text-left xl:items-start">
        <div className="flex items-start justify-center gap-2 mb-4">
          <Icon icon={faCalendarLines} className="text-blue-600 w-6 h-6 mt-1" size="xl" />
          <h2 data-testid={DataTestIdEnum.CTA_INDEX_CARD_TITLE} className="text-xl font-semibold text-gray-800">
            {title}
          </h2>
        </div>

        <p data-testid={DataTestIdEnum.CTA_INDEX_CARD_DESCRIPTION} className="text-gray-700 mb-6 text-justify">
          Se você procura por um
          {' '}
          {procedure?.name}
          {' '}
          em
          {' '}
          {place?.city}
          , conte com a Medprev. Aqui você agenda consultas e
          exames por valores acessíveis, sem mensalidade e sem taxa de adesão.
        </p>

        <div className="flex flex-col gap-3 w-full xl:flex-row xl:gap-4">
          <CtaSection rules={rules} procedure={procedure} place={place} branches={branches} searchType={searchType} originCta={originCta} />
        </div>
      </Card>
    </div>
  );
}
